import React, { useState } from "react";
import PropTypes from "prop-types";
import BrandGet from "./BrandGet";

import { BlackButton } from "../../components/CustomButtons";
import { Dialog } from "../../components/CustomComponents";

function BrandPreview({ isSelected, id }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <BlackButton
        variant="contained"
        color="primary"
        disabled={isSelected === false}
        sx={{ m: 1 }}
        onClick={handleClickOpen}
      >
        Preview
      </BlackButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-preview-brand"
        scroll="body"
        maxWidth="lg"
        fullWidth
      >
        <BrandGet id={id} />
      </Dialog>
    </React.Fragment>
  );
}

BrandPreview.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
};

export default BrandPreview;
